import { LabelResource } from '../../../Entities/Label';
import { LabelValueResource } from '../../../Entities/LabelValue';
import { LABEL_INPUT_TYPE } from '../../Labels/inputTypes';

export type LabelFieldValue = string | string[];

export interface LabelChoice {
  id: string;
  name: string;
}

export function getCharacteristicKey(labelId: string): string {
  return `label_${labelId}`;
}

export function normalizeChoiceValue(choices: LabelChoice[], value: string): string {
  const trimmedValue = value.trim();

  return (
    choices.find(
      (choice) => choice.id.trim().toLocaleLowerCase() === trimmedValue.toLocaleLowerCase(),
    )?.id ?? trimmedValue
  );
}

export function toLabelChoices(labelValues: LabelValueResource[]): LabelChoice[] {
  return labelValues.map((labelValue) => ({
    id: (labelValue.attributes.value ?? '').trim(),
    name:
      (labelValue.attributes.name ?? '').trim() ||
      (labelValue.attributes.value ?? '').trim() ||
      'Unnamed choice',
  }));
}

export function toFormValue(label: LabelResource, value: string | undefined): LabelFieldValue {
  if (label.attributes.input_type === LABEL_INPUT_TYPE.LIST) {
    return value
      ? value
          .split(',')
          .map((item) => item.trim())
          .filter((item) => item.length > 0)
      : [];
  }

  return (value ?? '').trim();
}

export function toStoredValue(value: LabelFieldValue): string {
  if (Array.isArray(value)) {
    return value
      .map((item) => item.trim())
      .filter((item) => item.length > 0)
      .join(',');
  }

  return (value ?? '').trim();
}

export function getLabelHelperText(label: LabelResource): string | undefined {
  const unit = (label.attributes.unit ?? '').trim();
  const direction = (label.attributes.direction ?? '').trim();

  return (
    [unit, direction]
      .filter((part) => part.length > 0)
      .join(' ')
      .trim() ?? undefined
  );
}
